import { TemplateElement, defineElement, html } from '@webtides/element-js';
import '../../../tab-panel/tab-panel.js';

/**
 * @property {string} title - Tab link text (used by e-banking-tab-group to create tab links)
 * @property {string} name - Unique identifier for the tab
 */
export default class EBankingTabItem extends TemplateElement {
    constructor() {
        super({ shadowRender: true });
    }

    properties() {
        return {
            title: '',
            name: '',
        };
    }

    template() {
        return html`
            <mb-tab-panel name="${this.name}">
                <slot></slot>
            </mb-tab-panel>
        `;
    }
}

defineElement('mb-e-banking-tab-item', EBankingTabItem);
